import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    onboardingUrl: String,
    redirectUrl: String,
    widgetId: String
  }

  connect() {
    this.initWidget()
  }

  initWidget() {
    LemonwayWidget.init(
      this.onboardingUrlValue,
      this.widgetIdValue,
      {
        lang: "fr",
        isSidebarMenuEnabled: true,
        arePersonalFieldsReadonly: true,
        isWelcomePageEnabled: false,
        onMyAccount: () => this.redirectToNextStep(),
        onFinish: () => this.redirectToNextStep(true),
        onPageChange: () => window.scrollTo({
          top: 0,
          behavior: "smooth",
        })
      }
    )
  }

  redirectToNextStep(completed = false) {
    const url = new URL(this.redirectUrlValue)
    url.searchParams.set("completed", completed ? 1 : 0)
    window.location.replace(url)
  }
}
